import { render, staticRenderFns } from "./stripeWaitPayment.vue?vue&type=template&id=ee5d7188&scoped=true"
import script from "./stripeWaitPayment.vue?vue&type=script&lang=js"
export * from "./stripeWaitPayment.vue?vue&type=script&lang=js"
import style0 from "./stripeWaitPayment.vue?vue&type=style&index=0&id=ee5d7188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5d7188",
  null
  
)

export default component.exports